import React from 'react';
import { ChatConfig } from '../types';
import { getBrandingColor } from '../utils/brandingUtils';

interface EmailCaptureModalProps {
  email: string;
  setEmail: (value: string) => void;
  captureSubmitted: boolean;
  handleEmailSubmit: (e: React.FormEvent) => void;
  setShowEmailCapture: (value: boolean) => void;
  endSession: (reason?: string) => void;
  config: ChatConfig | null;
}

/**
 * Renders the modal for capturing user email before ending the chat.
 */
export const EmailCaptureModal: React.FC<EmailCaptureModalProps> = ({
  email,
  setEmail,
  captureSubmitted,
  handleEmailSubmit,
  setShowEmailCapture,
  endSession,
  config,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full shadow-xl">
        {!captureSubmitted ? (
          <>
            <h2 className="text-xl font-semibold mb-4">Before you go...</h2>
            <p className="mb-4">Please enter your email address to receive updates about your mattress search!</p>
            <form onSubmit={handleEmailSubmit} className="space-y-4">
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="flex space-x-3">
                <button
                  type="submit"
                  className="flex-1 px-4 py-2 text-white rounded-md"
                  style={{ backgroundColor: getBrandingColor(config, 'primary') }}
                >
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowEmailCapture(false);
                    endSession('skipped_email'); // Provide reason
                  }}
                  className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-md"
                >
                  Skip
                </button>
              </div>
            </form>
          </>
        ) : (
          <div className="text-center py-4">
            <div className="text-green-500 mb-2">
              {/* Simple checkmark icon */}
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold mb-2">Thank You!</h2>
            <p className="mb-4">Your information has been submitted.</p>
            <button
              onClick={() => {
                // Optionally reload or just close modal
                setShowEmailCapture(false); 
                // Consider if reload is always desired after submission
                // window.location.reload(); 
              }}
              className="px-4 py-2 text-white rounded-md"
              style={{ backgroundColor: getBrandingColor(config, 'primary') }}
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}; 